import DropdownIndicator from "@/components/ReactSelect/DropDownIndicator"
import {
  type CustomSettings,
  useGetReactSelectStyles,
} from "@/theme/components-style-overrides/reactselect-definition"
import type { SimpleOption } from "@/utils/form/constants"
import Select, { type GroupBase, type Props } from "react-select"

export type ReactSelectProps = Omit<
  Props<SimpleOption, false, GroupBase<SimpleOption>>,
  "isMulti"
> & {
  defaultValue?: SimpleOption
  isMulti?: false
  onChange?: (value: SimpleOption | null) => void
  options?: SimpleOption[]
  value?: SimpleOption
  style?: CustomSettings
}

export const ReactSelect: React.FC<ReactSelectProps> = ({ style, ...props }) => {
  const reactSelectStyles = useGetReactSelectStyles(undefined, style)

  return (
    <Select
      components={{ DropdownIndicator }}
      variant="outline"
      styles={reactSelectStyles}
      {...props}
    />
  )
}
